<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="10" offset-md="1" xl="8" offset-xl="2">
                <routine-creator/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import RoutineCreator from "@/components/coach/routines/RoutineCreator";
import {Keyboard} from "@/utils/Capacitor";

export default {
    components: {
        RoutineCreator
    },
    data() {
        return {}
    },
    async mounted() {
        const vm = this
        await Keyboard.setResizeMode('body')
    },
    async beforeDestroy() {
        const vm = this
        await Keyboard.setResizeMode('native')
    }

}

</script>

<style scoped>


</style>